/**
 * Fire a visitor-analytics event, if the tracker is present and the visitor has
 * not opted out.
 *
 * Deliberately a no-op when window.bpTrack is absent: analytics is additive and
 * must never be a prerequisite for a dashboard action working. Only
 * non-financial product events go through here — payment outcomes are recorded
 * server-side from verified records and are rejected if posted by a browser.
 */
export function bpTrack(event: string, props?: Record<string, string | number | boolean>) {
  try {
    (window as unknown as { bpTrack?: (e: string, p?: unknown) => void }).bpTrack?.(event, props);
  } catch {
    /* never surface an analytics failure to the user */
  }
}
